<i nz-icon nzType="loading" *ngIf="nzLoading"></i>
<ng-content></ng-content>
